// extracted by mini-css-extract-plugin
module.exports = {"cat":"widget_cat__2W_4T","hand":"widget_hand__1kKUS"};